import React from "react";
import styles from "./graodeamormaternidade.module.scss";
import logoImg from "./src/logo.png";
import { FaWhatsapp, FaMapMarkerAlt, FaInstagram, FaBook } from "react-icons/fa";

const botoes = [
    { label: "LAYLA", icon: FaWhatsapp, href: "https://wa.me/message/WQAJLYO7W3FVM1" },
    { label: "DANIANE", icon: FaWhatsapp, href: "https://wa.me/message/6SUVHJIRGWQRD1" },
    { label: "LOCALIZAÇÃO", icon: FaMapMarkerAlt, href: "https://maps.app.goo.gl/TWnF65EwuyN5ynsb8?g_st=iwb" },
    { label: "INSTAGRAM", icon: FaInstagram, href: "https://www.instagram.com/graodeamor.maternidade?igsh=ODlzYWI4bmZzZjl1" },
    { label: "CATÁLOGO", icon: FaBook, href: "#" },
];

const Graodeamormaternidade: React.FC = () => {
    return (
        <div className={styles.graodeamormaternidade}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <img
                        src={logoImg}
                        alt="Grão de Amor Maternidade"
                        className={styles.logo}
                    />
                    <h1 className={styles.brandName}>Grão de Amor Maternidade</h1>
                    <p className={styles.tagline}>♡ Amor em cada detalhe ♡</p>
                </div>

                <nav className={styles.links}>
                    {botoes.map((btn, i) => {
                        const Icon = btn.icon;
                        return (
                            <a
                                key={i}
                                href={btn.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.linkBtn}
                            >
                                <Icon className={styles.linkIcon} />
                                <span>{btn.label}</span>
                            </a>
                        );
                    })}
                </nav>
            </div>
        </div>
    );
};

export default Graodeamormaternidade;
